var exports = {
  "g4": "MyProfileTab.module__loadingContainer___SDViVm",
  "MT": "MyProfileTab.module__contentLayout___SDViVm",
  "v$": "MyProfileTab.module__formColumn___SDViVm",
  "c9": "MyProfileTab.module__inputFooter___SDViVm",
  "fU": "MyProfileTab.module__opacityHalf___SDViVm",
  "Bo": "MyProfileTab.module__previewColumn___SDViVm",
  "sM": "MyProfileTab.module__srOnly___SDViVm",
};

module.exports = exports;
